import api from './client';
let token = null;
let generation = 0;
export const setFinanceToken = value => { token = value; generation++; };
export const clearFinanceAccess = () => {
  setFinanceToken(null);
  window.dispatchEvent(new Event('finance:locked'));
};
export async function financeRequest(method, path, data, signal) {
  const version = generation;
  try {
    const response = await api.request({ method, url: `/finance${path}`, data, signal, headers: { 'X-Finance-Intent': 'manage', ...(token ? { 'X-Finance-Token': token } : {}) } });
    if (version !== generation) throw new Error('Payments access changed. Please try again.');
    if (token && path !== '/access' && path !== '/lock') window.dispatchEvent(new Event('finance:activity'));
    return response.data;
  } catch (error) {
    if (version === generation && (error.status === 401 || (token && [403, 423].includes(error.status)))) clearFinanceAccess();
    throw error;
  }
}
export const financeMoney = value => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format((value || 0) / 100);
export const financeToday = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata' }).format(new Date());
